import { accountsActions } from './accounts';
import { authActions } from './auth';
import { calendarActions } from './calendar';
import { calendarActions2 } from './calendar2';
import { contactInfoActions } from './contact-info';
import { daemonsActions } from './daemons';
import { finesActions } from './fines';
import { pluginActions } from './plugin';
import { reportArchivesActions } from './report-archives';
import { reportsActions } from './reports';
import { staffActions } from './staff';
import { statisticsActions } from './statistics';
import { transfersActions } from './transfers';
import { usersActions } from './users';
import { giftsActions } from './gifts';
import { paymentActions } from './payment';
import { homeActions } from './home';
import { payersActions } from './payers';
import { dashboardActions } from './dashboard';
import { generalProfileActions } from './general';
import { shareLinksActions } from './shared-links';
import { walletActions } from './wallet';
import { chatsActions } from './chats';


export {
  reportsActions,
  accountsActions,
  authActions,
  homeActions,
  usersActions,
  daemonsActions,
  pluginActions,
  staffActions,
  statisticsActions,
  calendarActions,
  calendarActions2,
  finesActions,
  transfersActions,
  reportArchivesActions,
  contactInfoActions,
  giftsActions,
  paymentActions,
  payersActions,
  dashboardActions,
  generalProfileActions,
  shareLinksActions,
  walletActions,
  chatsActions
};
